<div
  class="tw-bg-white tw-m-auto tw-rounded-[10px] tw-py-[15px] tw-px-[15px] md:!tw-px-5 tw-mx-2.5 md:!tw-mx-auto tw-mt-[15px] tw-border-solid tw-border-gray-200"
>
  <div
    class="tw-flex tw-flex-col md:!tw-flex-row tw-justify-between tw-items-start tw-gap-[15px] md:!tw-gap-5"
  >
    @for (step of steps; track step.title; let i = $index) {
      <div
        class="tw-flex tw-flex-row tw-gap-4 tw-items-start tw-w-full md:!tw-w-auto md:!tw-flex-1"
      >
        <rv-badge
          shape="icon"
          class="tw-size-10"
          [color]="step.color"
          [icon]="step.icon"
        />
        <div class="tw-flex tw-flex-col tw-gap-[2.5px]">
          <span class="tw-font-semibold tw-text-gray-900 tw-text-[15px]">
            {{ step.title }}
          </span>
          <span class="tw-text-gray-500 tw-text-sm">{{ step.body }}</span>
        </div>
      </div>
    }
  </div>
</div>
